export const AVATAR_SIZE = 50;
export const AVATAR_OFFSET = 5;
